import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MaintenanceStatus } from '../core/services/maintenance-status.enum';

@Component({
  selector: 'environment-status',
  templateUrl: './environment-status.component.html',
  styleUrls: ['./environment-status.component.scss']
})
export class EnvironmentStatusComponent implements OnInit {

  public statusLabel: string = '';
  public backgroudStyle: string = '';
  public backgroudStyleBtn: string = '';
  @Input() status: MaintenanceStatus = MaintenanceStatus.ACTIVE;
  @Output() verifyServiceAvailability = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.status === MaintenanceStatus.ACTIVE) {
      this.statusLabel = 'Running';
      this.backgroudStyle = 'environment-status environment-status-running';
      this.backgroudStyleBtn = 'environment-status-container__message environment-status-container__message-running';
    }
    else if (this.status === MaintenanceStatus.RESTARTING || this.status === MaintenanceStatus.ERROR) {
      this.statusLabel = 'Restarting';
      this.backgroudStyle = 'environment-status environment-status-restarting';
      this.backgroudStyleBtn = 'environment-status-container__message environment-status-container__message-restarting';
    } else if (this.status === MaintenanceStatus.VERIFYING) {
      this.statusLabel = 'Checking';
      this.backgroudStyle = 'environment-status environment-status-restarting';
      this.backgroudStyleBtn = 'environment-status-container__message environment-status-container__message-restarting';
    } else {
      this.statusLabel = 'Maintenance'
      this.backgroudStyle = 'environment-status environment-status-maintenance';
      this.backgroudStyleBtn = 'environment-status-container__message environment-status-container__message-maintenance';
    }
  }

  verifyService() {
    this.verifyServiceAvailability.emit();
  }

  get isError() {
    return this.status === MaintenanceStatus.ERROR;
  }
}
